import ColumnTypes from '@/utils/ColumnTypes';
const contact_name = {
	key: 'contact_name',
	label: '姓名',
	type: 'rdText',
	minWidth: '80',
};
const wechat_account = {
	key: 'wechat_account',
	label: '微信号',
	type: 'rdText',
	minWidth: '80',
};
const mobile = {
	key: 'mobile',
	label: '手机号',
	type: 'rdText',
	minWidth: '80',
};
const add_time = {
	key: 'add_time',
	label: '创建时间',
	type: 'rdText',
	minWidth: '80',
};
const remark = {
	key: 'remark',
	label: '备注',
	type: 'rdText',
	minWidth: '180',
};
const operations = {
	key: 'operations',
	label: '操作',
	type: ColumnTypes.ButtonsCell,
	minWidth: '80',
	fixed: 'right',
	align: 'right',
};
export const columns = [contact_name, wechat_account, mobile, add_time, remark, operations];
